/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ServiceBillingType } from './serviceBillingType';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { SubscriptionType } from './subscriptionType';
import { VasServiceTypeEnum } from './vasServiceTypeEnum';


export interface VasServiceDto { 
    serviceName?: string;
    serviceProviderId: number;
    serviceProviderName?: string;
    note?: string;
    industryCode?: string;
    industry?: string;
    networkCode?: string;
    routeTypeName?: string;
    country?: string;
    countryCode?: string;
    mnc?: string;
    mcc?: string;
    category: number;
    price: number;
    vasServiceType: VasServiceTypeEnum;
    shortCode?: string;
    subcriptionType: SubscriptionType;
    periodicity: number;
    applicationId: number;
    frequency: number;
    activeDate: Date;
    expiryDate: Date;
    serviceStatus: number;
    channel?: string;
    operatorIds?: string;
    keyword?: string;
    unsubscriptionKeyword?: string;
    shortCodeKeyNumber?: string;
    billBasisId: number;
    billPerTransactionCount: number;
    mobileOriginatingCount: number;
    mobileTerminatingCount: number;
    createdOn: Date;
    active: boolean;
    contentPartnerName?: string;
    smsRouteName?: string;
    billingShortCode?: string;
    serviceTypeCategory: ServiceTypeEnum;
    serviceFee: number;
    revenueShare: number;
    billingType: ServiceBillingType;
}
